import StorageProvider from './storageProvider';

export default class AppSettingsService {
  static storage = new StorageProvider(
    window.sessionStorage,
    (storageProvider, key, value) => {
      storageProvider.setItem(key, JSON.stringify(value));
    },
    (storageProvider, key) => {
      const value = storageProvider.getItem(key);
      return value ? JSON.parse(value) : null;
    },
    (storageProvider, key) => {
      storageProvider.removeItem(key);
    },
    process.env.NODE_ENV === 'development' ? '_settings' : '_s',
    {
      tenantName: process.env.NODE_ENV === 'development' ? 'tenantName' : 'tn',
      bigLogo: process.env.NODE_ENV === 'development' ? 'bigLogo' : 'bl',
      smallLogo: process.env.NODE_ENV === 'development' ? 'smallLogo' : 'sl'
    }
  );

  static saveTenantName(tenantName) {
    this.storage.saveElement('tenantName', tenantName);
  }

  static getTenantName() {
    return this.storage.getElement('tenantName');
  }

  static removeTenantName() {
    return this.storage.removeElement('tenantName');
  }

  static saveBigLogo(bigLogo) {
    this.storage.saveElement('bigLogo', bigLogo);
  }

  static getBigLogo() {
    return this.storage.getElement('bigLogo');
  }

  static removeBigLogo() {
    return this.storage.removeElement('bigLogo');
  }

  static saveSmallLogo(smallLogo) {
    this.storage.saveElement('smallLogo', smallLogo);
  }

  static getSmallLogo() {
    return this.storage.getElement('smallLogo');
  }

  static removeSmallLogo() {
    return this.storage.removeElement('smallLogo');
  }
}
